import React, {Component} from 'react'
import {AppWrapper} from './AppWrapper'
import {SignIn} from './SignIn'

class AuthWrapper extends Component {
  constructor(props) {
    super(props)
    this.state = {
      username: '',
    }
    this.updateUsername = this.updateUsername.bind(this)
  }

  updateUsername(newUsername) {
    this.setState({username: newUsername})
  }

  render() {
    return (
      <div className="flex-1">
        <SignIn
          authState={this.props.authState}
          updateUsername={this.updateUsername}
          onStateChange={this.props.onStateChange}
        />
        <AppWrapper authState={this.props.authState} onStateChange={this.props.onStateChange} />
      </div>
    )
  }
}

export default AuthWrapper